import { render, staticRenderFns } from "./CreditTab.vue?vue&type=template&id=fdbe8b48&"
import script from "./CreditTab.vue?vue&type=script&lang=js&"
export * from "./CreditTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports